import { useState, useContext, useEffect } from 'react';
import { Flex, Text, IconButton, Avatar, Icon, useDisclosure, Accordion, AccordionItem, AccordionButton, AccordionPanel } from '@chakra-ui/react';

import { ImLeaf } from 'react-icons/im';
import { IoIosSnow } from 'react-icons/io';
import { LuWheatOff, LuWheat, LuVegan } from 'react-icons/lu'
import { HiPlus } from 'react-icons/hi';
import { BiMinus } from 'react-icons/bi';

import { connect } from 'react-redux';

import { tabellaAllergeni } from '../../i18n/AllergensTable';
import { cookies } from '../../CookiesHandler/cookies';
import MenuItemModal from './MenuItemModal'; 

import { CartContext } from '../CartContext';
import { TopMenuContext } from '../TopMenuContext';

import { extractNameFromMenuItemKey, extractDescriptionFromMenuItemKey, extractGastronomicMatchesForDish, extractTechnicalitiesForDish } from '../../utils/ExtractInternationalizedKeyFromCategory'
import { sortFlattenedVariants } from '../../utils/Dishes Graph/SortFlattenedVariants';
import { collectPaths } from '../../utils/DirectedGraph+Traversal';
import FeedInAppLogo from '../../assets/avatar_placeholder.png'

import './Styles/Menu.css';

const mapStateToProps = (state) => {
    return {
        menuGraph: state.dishesByCategoriesGraphLookup,
        dishesLookups: state.dishesLookup
    }
}


//TODO: What if a dish in the graph is hidden but its variants are not???? Maybe use shouldInclude to cutoff its subgraph????
const MenuListItem = connect(mapStateToProps)(
    (props) => {

        const { categoryID, ID } = props;
        const { isOpen, onOpen, onClose } = useDisclosure();
        const [cart, setCart] = useContext( CartContext );

        const cachedItem = cart.find( (item) => item.ID === props.ID )
        const cachedPurcaseCount = cachedItem ? cachedItem.amount : 0 

        const [purchaseCount, setPurchaseCount] = useState(cachedPurcaseCount); 
        const [thisDish, setThisDish] = useState(null)

        const [topMenuValues, setTopMenuValues] = useContext( TopMenuContext );
        
        const [flattenedVariants, setFlattenedVariants ] = useState(null) 

        const currentLang = cookies.get('i18next');
        const disabled = false; 

        /**
         * Reimposta il numero di volte che l'elemento è selezionato, ma solo quando viene svuotato il carrello
         */
        useEffect( () => {

            if(cart.length<=0)
                setPurchaseCount(0);

        }, [cart] );

        useEffect(() => {
            if (!!ID && !!categoryID && !!props.dishesLookups && !!props.dishesLookups[categoryID]) {
                setThisDish(props.dishesLookups[categoryID][ID])
            }
        }, [ID, categoryID, props.dishesLookups])



        useEffect(() => {
            if (!!props.menuGraph && !!categoryID && !!ID && !!props.dishesLookups) {
                const graphForCurrentCategory = props.menuGraph[categoryID]

                if (!!graphForCurrentCategory) {
                    const thisDishSubgraph = graphForCurrentCategory.getVertex(ID)

                    if (!!thisDishSubgraph) {
                        let variants = collectPaths(
                            graphForCurrentCategory, ID, null, null
                        )

                        if (variants.length > 0) {
                            sortFlattenedVariants(
                                /*allPaths:*/ variants,
                                /*dishesInCategory:*/ props.dishesLookups[categoryID]
                            )
                        } 
 
                        variants = variants
                                ?.map( path => path.length > 1 ? [...path.slice(1)] : null)
                                ?.filter( path => (path !== null && path.length > 0) ) 

                        if (variants.length > 0) {
                            setFlattenedVariants(variants)
                        }
                    }
                }
            }
        }, [props.menuGraph, categoryID, ID, props.dishesLookups])

        const handleRemove = ()=> {
            if (!!thisDish) {
                const isRemoved = --cart.find( (item) => item.ID === props.ID ).amount;

                if( isRemoved <= 0 ) 
                    setCart( cart.filter( (element) =>  element.ID !== props.ID ) );
            }
        }

        const handleAdd = () => {
            if( !cart.some( (item) => item.ID === props.ID ) && !!thisDish )
                cart.push( {
                    ID: props.ID,
                    name: props.name,
                    price: thisDish.price,
                    amount: 1,
                } );
            else 
                cart.find( (item) => item.ID === props.ID ).amount++;
        }

        const topLevelDishView = !!thisDish && (
            <>
                <Flex width="100%" mt="2" pt="2" pb="4" pl={2} pr={2} direction="row" className="smallBorder">
                    { props.includeImage && <Avatar size="md" src={thisDish.image ?? FeedInAppLogo} mr={4}/> }

                    <Flex direction="column" width="68%" onClick={ onOpen } className={  !disabled ? "clickable":"disabled" } >
                        <Text fontWeight="500" fontSize={props.isTopLevel ? "md":"sm"} 
                            color={ !disabled ? !props.isTopLevel ? "lightblack": "subitemblack" : "disabled" } 
                            lineHeight="5" mb={1}>
                            
                            { props.name }
                            { thisDish.vegetarian ? <Icon as={ImLeaf} color="primary" boxSize="15px" ml={2}/> : null }
                            { thisDish.vegan ? <Icon as={LuVegan} color="rgb(0, 128, 0)" boxSize="15px" ml={2}/> : null }
                            { thisDish.glutenFree === true ?  <Icon as={LuWheatOff} color="orange.600" boxSize="15px" ml={2}/> : null}
                            { thisDish.glutenFree === false ?  <Icon as={LuWheat} color="orange.600" boxSize="15px" ml={2}/> : null}
                            { thisDish.frozen ? <Icon as={IoIosSnow} color="frozen" boxSize="19px" ml={2}/> : null }

                        </Text>
                        <Text  fontWeight="400" fontSize={props.isTopLevel ? "smaller":"xs"} 
                                color={ !disabled ? "descriptionGrey": "disabled" } lineHeight="shorter" className="capitalize">
                            { props.description}
                        </Text>

                    </Flex>

                    { (thisDish.price && thisDish.price > 0 ) &&

                        <Flex  ml="auto" direction="column">
                            <Text fontWeight="medium" fontSize="medium" 
                                color={ !disabled ? "darkerGrey": "disabled" }
                                alignSelf="flex-end" whiteSpace="noWrap">
                                { thisDish.price + ' €' }
                            </Text>
                            
                            {   
                                !topMenuValues.stimaConto ? null : 
                                (purchaseCount <=0 || !cart) ? 
                                <IconButton 
                                    icon={<HiPlus />}
                                    variant="solid"
                                    backgroundColor="primary"
                                    color="white"
                                    isRound
                                    size="xs"
                                    alignSelf="flex-end"
                                    fontSize="24px"
                                    mr="1"
                                    marginTop="2px"
                                    disabled={ disabled }
                                    onClick= { ()=> { 
                                                    setPurchaseCount( purchaseCount+1 ); 
                                                    handleAdd(); 
                                                } 
                                            }
                                /> :
                                <Flex mr="1" marginTop="2px">
                                    <IconButton 
                                        icon={<BiMinus />}
                                        variant="unstyled"
                                        backgroundColor="primary"
                                        color="white"
                                        isfoo={props.hasCartUpdated ? "foo":"bar"}
                                        borderRadius="none"
                                        borderTopLeftRadius="lg"
                                        borderBottomLeftRadius="lg"
                                        size="xs"
                                        alignSelf="flex-end"
                                        fontSize="24px"
                                        disabled={ disabled }
                                        onClick= { ()=> { 
                                                            setPurchaseCount( purchaseCount-1 );
                                                            handleRemove() 
                                                        } 
                                                }

                                        _focus={{
                                            bg: "highlight",
                                        }}
                                    />
                                    <Flex width="24px" height="24px" justifyContent="center" alignItems="center" color="light" fontSize="small" 
                                            fontWeight="semibold" border="1px solid" borderTopColor="light" borderBottomColor="light">
                                        <Text>
                                            { purchaseCount }
                                        </Text>
                                    </Flex>
                                    <IconButton 
                                        icon={<HiPlus />}
                                        variant="unstyled"
                                        backgroundColor="primary"
                                        color="white"
                                        borderRadius="none"
                                        borderTopRightRadius="lg"
                                        borderBottomRightRadius="lg"
                                        size="xs"
                                        alignSelf="flex-end"
                                        fontSize="24px"
                                        
                                        disabled={ disabled }
                                        onClick= { ()=> { 
                                                    setPurchaseCount( purchaseCount+1 ); 
                                                    handleAdd(); 
                                                } 
                                            }

                                        _focus={{
                                            bg: "highlight",
                                        }}
                                    />
                                </Flex>
                            }
                            
                        </Flex>
                    }
                    
                </Flex>
                
                {                 
                (!disabled && !!thisDish && !thisDish["variants"]) &&
                    <MenuItemModal closeAction={ onClose } isDialogOpen={ isOpen } 
                                    name={ props.name } 
                                    description={ props.description } 
                                    price={ thisDish.price }
                                    image={ thisDish.image } 
                                    isVegetarian={ thisDish.vegetarian } 
                                    isFrozen={ thisDish.frozen }
                                    isVegan={ thisDish.vegan }
                                    isGlutenFree={ thisDish.glutenFree }
                                    allergens={ Object.keys(thisDish.allergeni)
                                        .map((allergen) => 
                                        thisDish.allergeni[allergen] ? 
                                                tabellaAllergeni[currentLang][allergen]  : null )
                                        .filter( (item) => item !== null ) 
                                    }
                                    designation={!!thisDish.designation && Object.keys(thisDish.designation)}
                                    gastronomicMatches={extractGastronomicMatchesForDish(thisDish)}
                                    technicalities={extractTechnicalitiesForDish(thisDish)}
                    />
                }
            </>
        )
        

        return (
            !!thisDish ?
            <>
                {  (!!flattenedVariants && props.renderRecursive) ?
                    <>
                        <Accordion allowMultiple p={0} m={0} variant="" defaultIndex={0}>
                            <AccordionItem border="0px">
                                <AccordionButton p={0} m={0} textAlign="left" _focus={{
                                    boxShadow: "0px"
                                }}>
                                { topLevelDishView }
                                    
                                </AccordionButton>
                                
                                <AccordionPanel pb={0} pt={0} pr={0}>
                                    {
                                        (!!flattenedVariants) &&
                                            <Flex direction="column">
                                                { flattenedVariants.map( (path, i) => {
                                                    return (
                                                        <MenuListItem 
                                                            ID = {path[path.length - 1]}
                                                            categoryID = {categoryID}
                                                            key = {`${path[path.length - 1]}/${i}`}
                                                            isTopLevel = {false}
                                                            name={path.map(variantID => extractNameFromMenuItemKey(variantID, categoryID, props.dishesLookups)).filter(substring => substring?.length > 0).join(", ")}
                                                            description={path.map(variantID => extractDescriptionFromMenuItemKey(variantID, categoryID, props.dishesLookups)).filter(substring => substring?.length > 0).join(", ")}
                                                            renderRecursive={false}
                                                            includeImage={props.includeImage}
                                                        />)
                                                    }) 
                                                }
                                            </Flex>
                                    }
                                </AccordionPanel>
                            </AccordionItem>
                        </Accordion>
                    </>
                        : 
                    topLevelDishView
                }
            </> : null
            
        )
    }
)

export default MenuListItem;